
import SubmitEmailMixin from '../../mixins/submit-email';

export default {
  mixins: [SubmitEmailMixin],
};
